export default __webpack_public_path__ + "static/gabrielwong1-2b9930580f8860b5e033b522a3fb9186.jpg";